import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { VersionModel } from './version.model';
import { SessionQuery, SessionStore } from '../../state';
import { EMPTY, Observable, catchError } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'cmg-clear2-ui-version-number',
  templateUrl: './version-number.component.html',
  styleUrls: ['./version-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
})
export class VersionNumberComponent implements OnInit {
  private readonly _httpClient = inject(HttpClient);
  private readonly _sessionStore = inject(SessionStore);
  private readonly _sessionQuery = inject(SessionQuery);

  versionNumber$: Observable<string>;
  private _defaultVersion = '2.0.0';
  private _versionJson: VersionModel;

  constructor() {
    this._httpClient
      .get('assets/app-version/version.json')
      .pipe(
        catchError(() => {
          this._sessionStore.update({
            clear2UIAppVersion: this._defaultVersion,
          });
          // eslint-disable-next-line
          console.error('version.json not found. Setting version to ' + this._defaultVersion);
          return EMPTY;
        }),
      )
      .subscribe((res) => {
        this._versionJson = <VersionModel>res;

        try {
          const isVersionValid = this._isVersionValid(this._versionJson?.version);
          if (isVersionValid) {
            this._sessionStore.update({
              clear2UIAppVersion: this._versionJson.version,
            });
          } else {
            // eslint-disable-next-line
            console.error('version.json invalid. Setting version to ' + this._defaultVersion);
            this._sessionStore.update({
              clear2UIAppVersion: this._defaultVersion,
            });
          }
        } catch {
          //
        }
      });
  }

  ngOnInit(): void {
    this.versionNumber$ = this._sessionQuery.select((t) => t.clear2UIAppVersion);
  }

  private _isVersionValid(version: string) {
    let isValid = true;

    // Version number should be in format <Major>.<Minor>.<Patch>

    if (version && version.length >= 5) {
      const versionFields = version.split('.');
      if (versionFields.length !== 3 || isNaN(Number(versionFields[0])) || isNaN(Number(versionFields[1])) || isNaN(Number(versionFields[2]))) {
        isValid = false;
      }
    } else {
      isValid = false;
    }

    return isValid;
  }
}
